var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFranceseDeselected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 205.61 347.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #eb4548;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #8486c0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raccolta"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.5,252.57c.25-.16-.18-.63-.26-.35l-.61.02s.05.06.08.09c.22.2.54.4.79.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.77,334.23c6.65-13.1,18.95-23.22,33.09-27.2,13.79-3.89,29.6-1.71,40.71,7.34,5.94,4.84,10.33,11.41,13.11,18.57,2.72,4.66,4.68,9.76,5.92,15.03h55.01c-46.21-49.24-78.1-111.78-90.73-178.12-6.23-32.72-7.86-66.12-9.48-99.38-1.15-23.71-2.86-46.76-4.01-70.47l-6.36,1.35c-1.26,57.59-3.06,115.46-13.73,172.07-10.67,56.61-30.65,112.33-65.26,158.39-4.59,6.1-9.56,12.13-16.03,16.16h52.62c1.35-4.72,2.93-9.36,5.15-13.74ZM85.71,217.7l24.42-1.03c.26,10.33,10.74,39.18,10.71,39.15l-43.31-2.07c5.23-12.34,7.47-24.69,8.17-36.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.97,269.79c-2.18-5.39-2.95-10.15-3.17-15.96H47.83c-1.6,5.9-3.47,11.73-5.58,17.47l116.72-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.17,202.3c-1.75-4.38-3.86-9.09-5.61-13.47h-51.04c-.65,5.19-2.01,10.29-4.04,15.11l60.69-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.81,36.53c.13-.05.04.24-.08.17s-.08-.25-.04-.38c1.38-3.81,2.07-7.87,2.03-11.92h16.01c.1,0-.43-.66-.52-.61s-.09.18-.08.28c.36,3.42.91,6.82,1.65,10.19.27,1.21.63,2.53,1.65,3.24l-20.62-.97Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFranceseDeselected);
export default __webpack_public_path__ + "static/media/franceseDeselected.0d28988a3c0128a8c2916150beb0a24c.svg";
export { ForwardRef as ReactComponent };